import { useForm } from "react-hook-form";
import { Form, FormItem, FormRow, FormError } from "@/components/form";
import { Flex } from "@/components/flex";
import { Button } from "@/components/button";
import { Loader } from "@/components/loader";
import { useAppDispatch, useAppSelector } from "src/config/store";
import { ITechnic } from "@/models/types";
import { createTechnic, editTechnic } from "@/reducers/technics-crud.reduce";
import ModalHeader from "@/components/modal/modal-header";
import ModalBody from "@/components/modal/modal-body";
import { validationSchema } from "src/utils/validation-utils";

type Props = {
  technic: ITechnic;
};

export const TechnicsEdit = (props: Props) => {
  const { technic } = props;

  const isEdit = technic.ID ? true : false;
  const dispatch = useAppDispatch();

  const technicsCrudState = useAppSelector((state) => state.technicsCrud);

  const {
    register,
    handleSubmit,

    formState: { errors, isValid },
  } = useForm({ mode: "onChange", defaultValues: technic });

  const save = (data) => {
    isEdit ? dispatch(editTechnic(data)) : dispatch(createTechnic(data));
  };

  return (
    <>
      <ModalHeader />
      <ModalBody>
        <Form>
          <FormRow>
            <FormItem name="post_title" label={"Nome"}>
              <input
                id="post_title"
                placeholder={"Nome"}
                {...register("post_title", validationSchema.required)}
              />

              {errors.post_title && <FormError error={errors.post_title.message} />}
            </FormItem>
          </FormRow>

          <FormRow>
            <FormItem>
              <Flex container alignItems="center">
                <Button
                  className="ml-auto"
                  size="md"
                  color="primary"
                  disabled={!isValid || technicsCrudState.loading}
                  onClick={handleSubmit(save)}
                >
                  {technicsCrudState.loading ? <Loader /> : "Salva"}
                </Button>
              </Flex>
            </FormItem>
          </FormRow>
        </Form>
      </ModalBody>
    </>
  );
};
